import type { VisitMedium } from '../../types';

type BadgeVariant = 'info' | 'warning' | 'success' | 'error' | 'neutral';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export function Badge({ variant = 'neutral', children, className, style }: BadgeProps) {
  return (
    <span className={`badge badge--${variant} ${className || ''}`} style={style}>
      {children}
    </span>
  );
}

const mediumStyles: Record<string, React.CSSProperties> = {
  video: { background: '#DBEAFE', color: '#1E40AF', padding: '2px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 600 },
  phone: { background: '#DCFCE7', color: '#166534', padding: '2px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 600 },
  sms: { background: '#CCFBF1', color: '#0D9488', padding: '2px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 600 },
};

const mediumLabels: Record<string, string> = {
  video: 'Video',
  phone: 'Phone',
  sms: 'SMS',
};

export function MediumBadge({ medium }: { medium: VisitMedium | string }) {
  const m = medium || 'video';
  return <span style={mediumStyles[m] || mediumStyles.video}>{mediumLabels[m] || 'Video'}</span>;
}

export function StatusBadge({ status }: { status: string }) {
  const badges: Record<string, { style: React.CSSProperties; label: string }> = {
    cancelled: { style: { background: '#FEE2E2', color: '#991B1B', padding: '2px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 600 }, label: 'Cancelled' },
    completed: { style: { background: '#D1FAE5', color: '#065F46', padding: '2px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 600 }, label: 'Completed' },
    ended: { style: { background: '#D1FAE5', color: '#065F46', padding: '2px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 600 }, label: 'Completed' },
  };
  const b = badges[status] || { style: { background: '#F3F4F6', color: '#6B7280', padding: '2px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 600 }, label: 'Expired' };
  return <span style={b.style}>{b.label}</span>;
}
